import React from 'react';

import WithAuth from '@repo/editor/src/components/WithAuth/WithAuth';
import { withEventScope } from '@repo/event-processor';
import { menuTheme } from '@repo/ui/components/Buttons';
import StarIcon from '@repo/ui/components/Icon/StarIcon';
import { BREAKPOINTS } from '@repo/ui/queries';
import { themeStyle, useTheme } from '@repo/ui/theming';

import AuthenticationButtonsWithSearchParams from 'components/HeadMenu/AuthenticationButtonsWithSearchParams';
import {
  links,
  getNavigationItemsList,
  trendingSearch,
} from 'components/HeadMenu/config';
import { ConfigurableSections } from 'components/HeadMenu/Header/constants';
import { HeaderProps } from 'components/HeadMenu/Header/types';
import HeaderSearch from 'components/HeadMenu/HeaderSeach/HeaderSearch';
import HeaderUserActions from 'components/HeadMenu/HeaderUserActions';
import LinkButton from 'components/LinkButton/LinkButton';
import { Container } from 'components/utilities/pageStyles';
import { FlexRow } from 'styles/layouts';

import LogoLink from '../LogoLink';

import NavigationItems from './NavigationItems/NavigationItems';
import { HeaderGrid, HeaderWrapper, WidthResolutions, Wrapper } from './styles';

const DesktopHeader: React.FC<HeaderProps> = ({
  onHome,
  inviteReferral,
  hiddenSections = [],
  ...props
}) => {
  const { isDarkTheme } = useTheme();

  return (
    <Wrapper hasBanner={props.hasBanner}>
      <HeaderWrapper data-testid="header">
        <Container>
          <HeaderGrid>
            <FlexRow alignItems="center" gap="12px">
              <LogoLink inviteReferral={inviteReferral} onHome={onHome} />
              {!hiddenSections.includes(ConfigurableSections.nav) && (
                <NavigationItems items={getNavigationItemsList(isDarkTheme)} />
              )}
            </FlexRow>

            <FlexRow alignItems="center">
              <WithAuth
                disableAnimation={true}
                renderAuth={(user, onLogOut): React.ReactNode => (
                  <HeaderUserActions user={user} onLogOut={onLogOut} />
                )}
                renderUnauth={(): React.ReactNode => (
                  <FlexRow gap="12px">
                    {!hiddenSections.includes(ConfigurableSections.search) && (
                      <HeaderSearch
                        dataTestId="header--search"
                        trendingSearch={trendingSearch}
                      />
                    )}
                    {!hiddenSections.includes(ConfigurableSections.pricing) && (
                      <LinkButton
                        height="40px"
                        href={links.PRICING}
                        icon={{ component: StarIcon }}
                        label="Plans"
                        theme={{
                          ...menuTheme,
                          color: themeStyle.varInkMain,
                        }}
                        width="100px"
                      />
                    )}
                    <WidthResolutions min={`${BREAKPOINTS.laptopMin}px`}>
                      <AuthenticationButtonsWithSearchParams
                        onSignup={props.onSignup}
                      />
                    </WidthResolutions>
                    <WidthResolutions
                      max={`${BREAKPOINTS.laptopMin - 1}px`}
                      min={`${BREAKPOINTS.largeTabletMin}px`}
                    >
                      <AuthenticationButtonsWithSearchParams
                        showSignInButton={false}
                        onSignup={props.onSignup}
                      />
                    </WidthResolutions>
                  </FlexRow>
                )}
              />
            </FlexRow>
          </HeaderGrid>
        </Container>
      </HeaderWrapper>
    </Wrapper>
  );
};

export default withEventScope(DesktopHeader, { module: 'desktopHeader' });
